/**
 * Telefon numarasını E.164 biçimine getirir. Varsayılan ülke Türkiye (+90).
 * Kabul edilen yazımlar: "0532 123 45 67", "532 123 45 67", "+90 (532) 123-45-67", "00905321234567", "905321234567".
 * Geçersizse null döner.
 */
export function normalizePhone(value) {
    let text = value.trim().replace(/[\s().-]+/g, "");
    if (text.startsWith("00"))
        text = `+${text.slice(2)}`;
    if (text.startsWith("+")) {
        const digits = text.slice(1);
        if (!/^\d{8,15}$/.test(digits))
            return null;
        if (digits.startsWith("90"))
            return isValidTrNational(digits.slice(2)) ? `+${digits}` : null;
        return `+${digits}`;
    }
    if (!/^\d+$/.test(text))
        return null;
    if (text.length === 12 && text.startsWith("90"))
        text = text.slice(2);
    else if (text.length === 11 && text.startsWith("0"))
        text = text.slice(1);
    return isValidTrNational(text) ? `+90${text}` : null;
}
/** Türkiye ulusal numarası: 10 hane; cep 5xx, sabit hat 2xx–4xx, özel servisler 8xx. */
function isValidTrNational(national) {
    return /^[2-58]\d{9}$/.test(national);
}
export function isValidPhone(value) {
    return normalizePhone(value) !== null;
}
/** Log ve ekranlar için maskeleme (KVKK): "+90532*****67" */
export function maskPhone(value) {
    const phone = normalizePhone(value) ?? value.replace(/\s+/g, "");
    if (phone.length < 7)
        return "****";
    return phone.slice(0, 6) + "*".repeat(phone.length - 8) + phone.slice(-2);
}
//# sourceMappingURL=phone.js.map